import SeatsSelector from "./SeatsSelector";
import FJLocalStore from '../../store/FJLocalStore';
import InlineSVG from 'react-inlinesvg';
import rightIcon from '../../icon/right.svg';
import questionIcon from '../../icon/question.svg';
import classNames from 'classnames';
import HoverDrop from '../common/HoverDrop';
import FJUtil from '../../util/FJUtil';
import {useDispatch, useSelector} from 'react-redux';
import FJViewConstant from '../../constant/FJViewConstant';
import { AUTO_SUBTITLE_PACKAGE_QUOTA, BACKGROUND_REMOVAL_PACKAGE_QUOTA } from '../../constant/FJValueConstant';
import Style from './PackageItem.module.less';
import {useState} from "react";
import mainAction from "../../reducer/action/mainAction";

const PackageItem = props => {
    let { popupType, itemData, changeStep, isAnnually } = props;
    let { name, buttonText } = itemData;
    let { currentPlan, discountConf, planType, calculatorSeatCount, teamSubscription } = useSelector(state => {
        return {
            currentPlan: state.mainReducer.currentPlan,
            discountConf: state.mainReducer.discountConf,
            planType: state.mainReducer.planType,
            calculatorSeatCount: state.mainReducer.calculatorSeatCount,
            teamSubscription: state.mainReducer.teamSubscription
        };
    });
    const [seatCount, setSeatCount] = useState(calculatorSeatCount);
    const dispatch = useDispatch();

    const shouldCreateTeam = () => {
        return teamSubscription == null;
    }

    let curPrice = isAnnually ? itemData.price.annual : itemData.price.monthly
    let _getPrice = (price) => {
        if (discountConf.openDiscount) {
            if (window.fjuser) {
                if (!window.fjuser.info.result || window.fjuser.info.policy == 'free') {
                    return Math.floor((price * discountConf.rate) * 100) / 100;
                }
            }
        }
        return price;
    };
    let _drawItem = () => {
        let features = popupType ? itemData.shortFeatures : itemData.features;
        if (planType === 'team' && itemData.package === 'free') {
            features = itemData.teamFeatures;
        }
        return features.map((item) => {
            let text;
            switch (item.key) {
                case FJViewConstant.AUTO_SUBTITLE: {
                    const quota = AUTO_SUBTITLE_PACKAGE_QUOTA[itemData.package];
                    const yearQuota = quota * 12;
                    text =
                        isAnnually && itemData.package !== 'free'
                            ? FJLocalStore._(item.yearText).replace('xxx', yearQuota)
                            : FJLocalStore._(item.monthText).replace('xxx', quota);
                    break;
                }
                case FJViewConstant.BACKGROUND_REMOVAL: {
                    text = FJLocalStore._(item.text).replace('xxx', BACKGROUND_REMOVAL_PACKAGE_QUOTA[itemData.package]);
                    break;
                }
                default:
                    text = FJLocalStore._(item.text);
            }

            let width = null;
            if (item.desc) {
                let fixedWidth = 190;
                if (planType === 'team') {
                    fixedWidth = 268;
                } else if (popupType) {
                    fixedWidth = 228;
                }
                width = FJUtil.calculateTextDimensions(text, fixedWidth, '14px Roboto').width;
            }

            return (
                <div key={item.text + item.key} className={Style.featureItem}>
                    <div className={Style.icon_box}>
                        <InlineSVG src={rightIcon} />
                    </div>
                    <span className={Style.text_box}>{text}</span>
                    {item.desc && (
                        <HoverDrop overlay={<div className={Style.question_drop}>{FJLocalStore._(item.desc)}</div>}>
                            <div className={Style.question_icon_box}>
                                <InlineSVG src={questionIcon} />
                            </div>
                        </HoverDrop>
                    )}
                </div>
            );
        });
    };
    let _planTotal = () => {
        if (!isAnnually) {
            if (planType === 'team') {
                const seatPrice = itemData.seatPrice?.monthly ?? 9.9;
                let price = itemData.price.monthly + (seatCount-3) * seatPrice;
                price = price.toFixed(2);
                return `$${_getPrice(price)}` + " " + FJLocalStore._('PLANS_MONTHLY_TOTAL');
            }
            return ''
        }

        let price;
        if (planType === 'team') {
            const seatPrice = itemData.seatPrice?.annual ?? 19.9;
            price = itemData.price.annual * 12 + (seatCount-3) * seatPrice * 12;
        } else {
            price = itemData.price.annual * 12;
        }
        price = price.toFixed(2);
        return `$${_getPrice(price)}` + " " + FJLocalStore._('PLANS_ANNUAL_TOTAL');
    };
    let _seatPrice = () => {
        if (planType === 'team') {
            const seatPrice = (isAnnually ? itemData.seatPrice?.annual : itemData.seatPrice?.monthly) ?? 19.9;
            return FJLocalStore._('Include-3-seats').replace('xxx', `${seatPrice}`);
        }
    }
    let _onClick = () => {
        // let type = itemData.package
        // changeStep(2, type)
        if (window.fjuser && !window.fjuser.isUserLogin()) {
            window.fjuser.addListener(window.fjuser.eventType.login | window.fjuser.eventType.register, (result, json) => {
                if (result) {
                    window.FJGlobalariable.modSubscription.showLoading = true;
                    window.FJGlobalariable.modSubscription.network.getSubscription().then((response) => {
                        window.FJGlobalariable.modSubscription.updateSubscriptionInfo(response.data.subscription);
                    }).catch((error) => {
                    }).finally(() => {
                        window.FJGlobalariable.modSubscription.showLoading = false;
                    });
                }
            }, true);
            window.fjuser.showLoginPanel();
        } else if (itemData.package === 'team' && shouldCreateTeam()) {
            window.open('/?showCreateTeamModal=true','_blank');
        } else {
            // 如果当前团队还未付费，那么将选择的席位数带过去，否则不带
            if (planType === 'team' && teamSubscription && teamSubscription.package === 'free') {
                dispatch(mainAction.updateSeatCount(seatCount));
            }
            // this.state.selectPlan = this.plan;
            // this.state.page = 'pay';
            let packageName = itemData.package
            changeStep(2, packageName)
            let selectedPeriod = () => {
                return isAnnually ? 'annual' : 'monthly'
            }
            FJUtil.ealog('choose plan select click', {
                'selectButton': packageName + ' ' + selectedPeriod(),
            });
        }
    }
    let selectedPeriod = () => {
        return isAnnually ? 'annual' : 'monthly';
    };

    const canPlanUpgrade = () => {
        let plan = {
            package: itemData.package,
            period: selectedPeriod()
        };
        if (planType === 'team') {
            plan.package = 'business';
            if (teamSubscription) {
                return window.checkPlanCanUpgrade(teamSubscription, plan);
            }
            return true;
        }
        return window.checkPlanCanUpgrade(currentPlan, plan);
    }
    let canSelect = () => {
        if (itemData.package === 'free') {
            return false;
        }

        if (itemData.package === 'team') {
            if (shouldCreateTeam()) {
                return true;
            } else {
                if (teamSubscription.package === 'free') {
                    return true;
                }
            }
        } else {
            if (currentPlan.package === 'free') {
                return true;
            }
        }

        return canPlanUpgrade();
    };

    const buttonDisplayText = () => {
        if (planType === 'team') {
            if (itemData.package === 'team') {
                if (shouldCreateTeam()) {
                    return FJLocalStore._('Create a Team');
                } else if (teamSubscription.package !== 'free' && !canPlanUpgrade()) {
                    return FJLocalStore._('Current Plan');
                } else {
                    return FJLocalStore._(buttonText);
                }
            } else {
                if (teamSubscription?.package === 'free') {
                    return FJLocalStore._('Current Plan');
                } else {
                    return FJLocalStore._(buttonText);
                }
            }
        }

        if (itemData.package === currentPlan.package && !canPlanUpgrade()) {
            return FJLocalStore._('Current Plan');
        }

        return FJLocalStore._(buttonText);
    }

    const seatsData = [
        {
            length: 3,
            title: '1-3',
        },
        {
            length: 5,
            title: '5',
        },
        {
            length: 10,
            title: '10',
        },
        {
            length: 20,
            title: '20',
        },
    ];

    const _onChangeSeats = (length) => {
        setSeatCount(length);
    }

    let initialSelectedIndex = seatsData.findIndex((seat) => seat.length === calculatorSeatCount);
    let initialValue = '';
    if (initialSelectedIndex === -1) {
        initialValue = `${calculatorSeatCount}`;
    }

    return (
        <div
            className={classNames(Style.listItem, {
                [Style.popup]: popupType,
                [Style.listItem_popular]: itemData.isPopular,
                [Style.team]: planType === 'team'
            })}
        >
            {itemData.isPopular && <div className={classNames(Style.popular, {
                [Style.team]: itemData.package === 'team'
            })}>
                {itemData.package === 'team' ? FJLocalStore._('Plan for 2+ people') : FJLocalStore._('PLANS_POPULAR')}
            </div>}
            <span className={Style.plan_name}>{FJLocalStore._(name)}</span>
            <div className={Style.price_box}>
                <span>$</span>
                <span className={Style.price}>{_getPrice(curPrice)}</span>
                <div className={Style.unit}>
                    <span
                        className={classNames(
                            Style.cut,
                            itemData.package === 'free' || !isAnnually ? Style.cut_hidden : '',
                        )}
                    >
                        ${_getPrice(itemData.price.monthly)}
                    </span>
                    <span>/{FJLocalStore._('PLANS_MO')}</span>
                </div>
            </div>
            <div className={Style.count_price} style={{opacity: itemData.package === 'free' ? 0 : 1}}>
                <div className={Style.seat_price}>{_seatPrice()}</div>
                <div className={Style.price_total}>{_planTotal()}</div>
            </div>
            <div
                onClick={canSelect() ? _onClick : null}
                className={classNames(Style.select_btn, {
                    [Style.select_btn_normal]: canSelect() && itemData.package !== 'plus' && itemData.package !== 'team',
                    [Style.select_btn_gray]: !canSelect()
                })}
            >
                {buttonDisplayText()}
            </div>
            { itemData.package === 'team' ? <div className={Style.seats_container}>
                <div className={Style.seats_title}>{FJLocalStore._('How many seats do you need?')}</div>
                <SeatsSelector seatsData={seatsData} initialValue={initialValue} initialSelectedIndex={initialSelectedIndex} classname={Style.seats_selector} onChangeSeats={_onChangeSeats} />
            </div> : null }
            <div className={Style.feature_list}>{_drawItem()}</div>
            {itemData.package !== 'free' && popupType ? (
                <a className={Style.more_btn} href={FJUtil.getPricingUri()} target='_blank'>
                    {FJLocalStore._('See-all-features')}
                </a>
            ) : null}
        </div>
    );
};
export default PackageItem;
